/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=fba928b0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=fba928b0&lang=css"

import exportComponent from "/var/www/teacher.liu.org/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__